import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, STATUS } from "../../../Constants";
import axios from "axios";


// For Get All Comment Post Of Page 
const getAllCommentsOfPostEndPoint = (args)=>`${DomainName}/page/comments?userAccessToken=${args.userToken}&postId=${args.postId}` ;

export const getAllCommentsOfPostAPI = createAsyncThunk('page/comments' , async (args , thunkAPI) =>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.get(getAllCommentsOfPostEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data.comments;
    }catch(error){
        return rejectWithValue(error);
    }
})

// for get specific post api
const specificPostEndpoint = (args)=> `${DomainName}/group/specPost?userAccessToken=${args.userToken}&postId=${args.postId}` ; 

export const getSpecificPostAPI = createAsyncThunk('specificpost/get' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(specificPostEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data?.post ;
    }catch(error){
        return rejectWithValue(error) ;
    }
})

// for initialize default state
const initialState = {
    post :{} , 
    status : STATUS.IDLE , 
    comments : [] , 
    statusOfComments : STATUS.IDLE
}

const SpecificPostSlice = createSlice({
    name : "specificpost" , 
    initialState , 
    reducers : {

    } , 
    extraReducers : (builder)=>{
        builder
        // For Get Specific Post
        .addCase(getSpecificPostAPI.fulfilled , (state , action)=>{
            state.post = action.payload ; 
            state.status = STATUS.SUCCESS ; 
        })
        .addCase(getSpecificPostAPI.pending , (state )=>{
            state.status = STATUS.LOADDING ;
        })
        .addCase(getSpecificPostAPI.rejected ,(state )=>{
            state.status = STATUS.ERROR ; 
        })

        // For get comments of specific post
        .addCase(getAllCommentsOfPostAPI.fulfilled , (state , action)=>{
            state.comments = action.payload ; 
            state.statusOfComments = STATUS.SUCCESS ;
        })
        .addCase(getAllCommentsOfPostAPI.pending , (state , action)=>{
            state.statusOfComments = STATUS.LOADDING ; 
        })
        .addCase(getAllCommentsOfPostAPI.rejected , (state , action)=>{
            state.statusOfComments = STATUS.ERROR ; 
        })
    }
})

export default SpecificPostSlice.reducer


export const getSpcifcPostData = (state ) => state.SpecificPostSlice ; 


export const getSpecificPostComments = (state) => state.SpecificPostSlice